import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'
import toast from 'react-hot-toast'

const { FiX, FiTag, FiPlus, FiLoader } = FiIcons

const NewCategoryModal = ({ isOpen, onClose, onAdd }) => {
  const [newCat, setNewCat] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!newCat.trim()) {
      toast.error("Category name cannot be empty")
      return
    }
    onAdd(newCat.trim())
    setNewCat('')
    onClose()
  }

  if (!isOpen) return null

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
        <motion.div 
          initial={{ opacity: 0 }} 
          animate={{ opacity: 1 }} 
          exit={{ opacity: 0 }} 
          onClick={onClose} 
          className="absolute inset-0 bg-space_indigo/60 backdrop-blur-md" 
        />
        <motion.div 
          initial={{ opacity: 0, scale: 0.95, y: 20 }} 
          animate={{ opacity: 1, scale: 1, y: 0 }} 
          exit={{ opacity: 0, scale: 0.95, y: 20 }} 
          className="bg-white w-full max-w-sm rounded-[2rem] shadow-2xl relative z-10 overflow-hidden border-2 border-white-400"
        >
          <div className="px-6 py-4 border-b-2 border-white-400 bg-white-500 flex items-center justify-between">
            <h3 className="text-sm font-black text-space_indigo uppercase tracking-widest flex items-center">
              <div className="bg-dark_cyan p-1.5 rounded-lg mr-3">
                <SafeIcon icon={FiPlus} className="w-3.5 h-3.5 text-white" />
              </div>
              New Category
            </h3>
            <button onClick={onClose} className="p-2 text-white-300 hover:text-hot_berry transition-colors">
              <SafeIcon icon={FiX} className="w-5 h-5" />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <div className="relative">
              <SafeIcon icon={FiTag} className="absolute left-4 top-1/2 -translate-y-1/2 text-white-400 w-4 h-4" />
              <input 
                autoFocus
                required 
                value={newCat} 
                onChange={(e) => setNewCat(e.target.value)} 
                className="w-full pl-11 pr-4 py-3 bg-white-500 border-2 border-white-400 rounded-xl focus:border-dark_cyan transition-all font-bold text-xs" 
                placeholder="e.g. Memoir, Sci-Fi..." 
              />
            </div>
            <button 
              type="submit" 
              className="w-full py-3.5 bg-dark_cyan text-white rounded-2xl font-black uppercase tracking-widest text-[10px] shadow-lg shadow-dark_cyan/20 transition-all"
            >
              Add & Select Category
            </button>
          </form>
        </motion.div>
      </div>
    </AnimatePresence>
  )
}

export default NewCategoryModal